
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1e7e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1e7e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jXEky", function(module, exports) {

$parcel$export(module.exports, "uriUserPage", function () { return $e882cfcc4184df66$export$ff3ad29dbb546598; });
$parcel$export(module.exports, "uriCollectionPage", function () { return $e882cfcc4184df66$export$36dfaec04418caa7; });
$parcel$export(module.exports, "UserRole", function () { return $e882cfcc4184df66$export$eb3485a690c2f0b8; });
$parcel$export(module.exports, "LevelPrivacy", function () { return $e882cfcc4184df66$export$a3c073b335a47d60; });
$parcel$export(module.exports, "PRIVACY_BADGE_STYLE", function () { return $e882cfcc4184df66$export$eba8c17f4d7a3cd3; });
$parcel$export(module.exports, "PRIVACY_BADGE_TEXT", function () { return $e882cfcc4184df66$export$ab4fdfae3dcd1a8f; });
$parcel$export(module.exports, "ROLE_BADGE_STYLE", function () { return $e882cfcc4184df66$export$f25eef55c66a4e9d; });
$parcel$export(module.exports, "startLoader", function () { return $e882cfcc4184df66$export$8afc507ca675ea0e; });
$parcel$export(module.exports, "cancelLoader", function () { return $e882cfcc4184df66$export$81e46b314cb8d8e3; });
$parcel$export(module.exports, "callJsonApi", function () { return $e882cfcc4184df66$export$997d30e836e5c567; });
$parcel$export(module.exports, "looksLikeMail", function () { return $e882cfcc4184df66$export$706cf9fcefe67c8e; });
$parcel$export(module.exports, "activateGoHomeLink", function () { return $e882cfcc4184df66$export$3fc781af82c0c660; });
$parcel$export(module.exports, "MEDIA_CONSTRAINTS", function () { return $e882cfcc4184df66$export$2464c9e69777d386; });

var $hbluw = parcelRequire("hbluw");
const $e882cfcc4184df66$export$ff3ad29dbb546598 = "/index.html?userid=";
const $e882cfcc4184df66$export$36dfaec04418caa7 = "/index.html?collectionid=";
const $e882cfcc4184df66$export$eb3485a690c2f0b8 = Object.freeze({
    none: 0,
    owner: 1,
    admin: 2,
    member: 3,
    guest: 4
});
const $e882cfcc4184df66$export$a3c073b335a47d60 = Object.freeze({
    public: 1,
    onlyreg: 2,
    private: 3
});
const $e882cfcc4184df66$export$eba8c17f4d7a3cd3 = {
    [$e882cfcc4184df66$export$a3c073b335a47d60.public]: "badge-public",
    [$e882cfcc4184df66$export$a3c073b335a47d60.onlyreg]: "badge-onlyreg",
    [$e882cfcc4184df66$export$a3c073b335a47d60.private]: "badge-private"
};
const $e882cfcc4184df66$export$ab4fdfae3dcd1a8f = {
    [$e882cfcc4184df66$export$a3c073b335a47d60.public]: "PUBLIC",
    [$e882cfcc4184df66$export$a3c073b335a47d60.onlyreg]: "REG USERS",
    [$e882cfcc4184df66$export$a3c073b335a47d60.private]: "PRIVATE"
};
const $e882cfcc4184df66$export$f25eef55c66a4e9d = {
    [$e882cfcc4184df66$export$eb3485a690c2f0b8.owner]: "badge-owner",
    [$e882cfcc4184df66$export$eb3485a690c2f0b8.admin]: "badge-admin",
    [$e882cfcc4184df66$export$eb3485a690c2f0b8.member]: "badge-member",
    [$e882cfcc4184df66$export$eb3485a690c2f0b8.guest]: "badge-guest"
};
const $e882cfcc4184df66$export$8afc507ca675ea0e = (loadingMessage)=>{
    const loaderElement = document.getElementById("loader");
    loaderElement.innerHTML = `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>&nbsp;${loadingMessage}`;
    loaderElement.classList.remove("loader-hidden");
};
const $e882cfcc4184df66$export$81e46b314cb8d8e3 = ()=>{
    const loaderElement = document.getElementById("loader");
    loaderElement.classList.add("loader-hidden");
};
const $e882cfcc4184df66$export$997d30e836e5c567 = async (apimethod, rqstmethod, body, useLoaderWithText)=>{
    const request = {
        method: rqstmethod || "GET",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };
    if (body) request.body = JSON.stringify(body);
    try {
        useLoaderWithText && $e882cfcc4184df66$export$8afc507ca675ea0e(useLoaderWithText);
        const sendRqst = await fetch((0, $hbluw.ENDPOINT) + apimethod, request);
        useLoaderWithText && $e882cfcc4184df66$export$81e46b314cb8d8e3();
        const respToJson = await sendRqst.json();
        if (respToJson && !respToJson.error) return respToJson;
        else return (respToJson === null || respToJson === void 0 ? void 0 : respToJson.error) || "An error occurred";
    } catch (error) {
        useLoaderWithText && $e882cfcc4184df66$export$81e46b314cb8d8e3();
        return error;
    }
};
const $e882cfcc4184df66$export$706cf9fcefe67c8e = (str)=>{
    const lastAtPos = str.lastIndexOf("@");
    const lastDotPos = str.lastIndexOf(".");
    return lastAtPos < lastDotPos && lastAtPos > 0 && str.indexOf("@@") == -1 && lastDotPos > 2 && str.length - lastDotPos > 2;
};
const $e882cfcc4184df66$export$3fc781af82c0c660 = ()=>{
    const goHomeLink = document.getElementById("goHome");
    if (window.location.host === "localhost:80" || window.location.origin === "http://localhost") goHomeLink.href = window.location.origin + "/index.html";
    else goHomeLink.href = window.location.origin;
};
const $e882cfcc4184df66$export$95df08bae54cb4df = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
const $e882cfcc4184df66$export$2464c9e69777d386 = {
    audio: {
        echoCancellation: false,
        noiseSuppression: false,
        autoGainControl: false,
        latency: 0,
        channelCount: 1
    }
};

});
parcelRegister("hbluw", function(module, exports) {

$parcel$export(module.exports, "ENDPOINT", function () { return $c82422755965d529$export$1a23c4610ef05bed; });
$parcel$export(module.exports, "UPLOAD_ENDPOINT", function () { return $c82422755965d529$export$cdda3773e71b07e4; });
const $c82422755965d529$var$MODE = "DEV" // 'DEV', 'STAGE', 'PROD'
;
const $c82422755965d529$var$ENVIRONMENTS = {
    PROD: {
        ENDPOINT: "https://hiaudio.fr",
        UPLOAD_ENDPOINT: "https://hiaudio.fr/fileUpload"
    },
    STAGE: {
        ENDPOINT: window.location.protocol + "//" + window.location.host,
        UPLOAD_ENDPOINT: window.location.protocol + "//" + window.location.host + "/fileUpload"
    },
    DEV: {
        ENDPOINT: window.location.protocol + "//" + window.location.host,
        UPLOAD_ENDPOINT: window.location.protocol + "//" + window.location.host + "/fileUpload"
    }
};
const $c82422755965d529$export$1a23c4610ef05bed = $c82422755965d529$var$ENVIRONMENTS[$c82422755965d529$var$MODE].ENDPOINT;
const $c82422755965d529$export$cdda3773e71b07e4 = $c82422755965d529$var$ENVIRONMENTS[$c82422755965d529$var$MODE].UPLOAD_ENDPOINT;

});



var $jXEky = parcelRequire("jXEky");
let $f64679c218fd5c75$var$TEMP_EMAIL = null;
const $f64679c218fd5c75$var$sendCodeButton = document.getElementById("sendcodebutton");
const $f64679c218fd5c75$var$redirectToGoogleLogin = ()=>{
    window.location.href = "/googlelogin";
};
const $f64679c218fd5c75$var$getUser = async ()=>{
    const data = await (0, $jXEky.callJsonApi)("/profile", "GET", null, "Loading user...");
    if (data.ok) window.location.href = window.location.origin + "/profile.html";
};
const $f64679c218fd5c75$var$sendVerificationCode = async ()=>{
    const loginEmail = document.getElementById("inputloginemail").value;
    if ((0, $jXEky.looksLikeMail)(loginEmail)) {
        $f64679c218fd5c75$var$sendCodeButton.disabled = true;
        const data = await (0, $jXEky.callJsonApi)("/generatelogincode/" + loginEmail, "PUT", null, "Sending code...");
        $f64679c218fd5c75$var$sendCodeButton.disabled = false;
        if (data.ok) {
            $f64679c218fd5c75$var$TEMP_EMAIL = loginEmail;
            document.getElementById("authmethodform").hidden = true;
            document.getElementById("validationcodefield").hidden = false;
        } else {
            document.getElementById("inputloginemail").classList.add("is-invalid");
            document.getElementById("validationEmailResult").innerText = data;
        }
    } else {
        document.getElementById("inputloginemail").classList.add("is-invalid");
        document.getElementById("validationEmailResult").innerText = "Sorry, invalid email address format.";
    }
};
const $f64679c218fd5c75$var$requestCodeValidation = async ()=>{
    const codeIs = document.getElementById("verificationCode").value;
    const sixDigits = /\d{6}/;
    if (sixDigits.test(codeIs)) {
        const body = {
            email: $f64679c218fd5c75$var$TEMP_EMAIL,
            code: codeIs
        };
        const data = await (0, $jXEky.callJsonApi)("/logincodevalidation", "POST", body, "Verification in process...");
        if (data.ok) {
            $f64679c218fd5c75$var$TEMP_EMAIL = null;
            window.location.href = window.location.origin;
        } else {
            // TODO: if the code is expired display button to request a new one
            document.getElementById("verificationCode").classList.add("is-invalid");
            document.getElementById("validationCodeResult").innerText = "Wrong code, sorry";
        }
    } else {
        document.getElementById("verificationCode").classList.add("is-invalid");
        document.getElementById("validationCodeResult").innerText = "Sorry, invalid code format.";
    }
};
(0, $jXEky.activateGoHomeLink)();
document.getElementById("googleLoginButton").onclick = $f64679c218fd5c75$var$redirectToGoogleLogin;
$f64679c218fd5c75$var$sendCodeButton.onclick = $f64679c218fd5c75$var$sendVerificationCode;
document.getElementById("inputloginemail").onkeydown = function(e) {
    if (e.key == "Enter") return $f64679c218fd5c75$var$sendVerificationCode();
};
document.getElementById("validatecodebutton").onclick = $f64679c218fd5c75$var$requestCodeValidation;
document.getElementById("verificationCode").onkeydown = function(e) {
    if (e.key == "Enter") return $f64679c218fd5c75$var$requestCodeValidation();
};
$f64679c218fd5c75$var$getUser();


//# sourceMappingURL=login.47f4f3a6.js.map
